import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {ThietBi} from '../../../models/danhmuc/thietbi';
import {DangKyService} from '../../../service/vpp/service-dangky';
import {ThietBiService} from '../../../service/danhmuc/service-thietbi';
import {DatePipe} from '@angular/common';
import {CommandUtil} from '../../../global/commandutil';
import {Sessioncommand} from '../../../global/sessioncommand';
import {SelectStaffComponent} from '../../ui/selectstaff/selectstaff.component';
import {StaffsService} from '../../../service/staff/service-staffs';
import {GroupSelectComponent} from '../group/groupselect.component';

import {DangKyNguoiDuyetService} from '../../../service/vpp/service-dangkynguoiduyet';

;

@Component({
  templateUrl: './edit.component.html'

})
export class EditDangKyComponent implements OnInit, AfterViewInit {
  @ViewChild(SelectStaffComponent)
  public uiSelectStaff: SelectStaffComponent;
  public language = language;
  public id: number=0;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public submitValidate = false;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public dataThietBi: ThietBi[];
  public gio: String= "";
  public dateCurrent: Date= new Date();
  public onClose: Subject<boolean>;
  public staffSelectList: Object[]=[];
  public selectedList: Object[]=[];
  public staffSelectReadList: Object[]=[];
  constructor( public dangKyService: DangKyService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public thietBiService: ThietBiService,
               public _bsModalRef: BsModalRef,
               public bsModalService: BsModalService,
               public datepipe: DatePipe,
               public commandUitls: CommandUtil,
               public staffsService: StaffsService,
               public dangKyNguoiDuyetService: DangKyNguoiDuyetService

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      dangKyId: new FormControl('0'),
      ngay: new FormControl(),
      ghiChu: new FormControl(''),
      phongID: new FormControl(0),
      noiDung: new FormControl(),
      thoiGian: new FormControl(),
      yeuCauTraLoi: new FormControl(),
      nguoiChuTri: new FormControl(),
      nguoiDangKyID: new FormControl(),
      trangThai: new FormControl(1)
    });
    this.frmGroup = this.formBuilder.group({
      dangKyId: ['' , Validators.compose([validateEmpty]) ],
      ngay: ['' , Validators.compose([validateEmpty]) ],
      noiDung: ['' , Validators.compose([validateEmpty]) ],
      ghiChu: ['', Validators.nullValidator],
      thoiGian: ['', Validators.nullValidator],
      phongID: ['0', Validators.nullValidator],
      yeuCauTraLoi: ['', Validators.nullValidator],
      nguoiChuTri: ['', Validators.nullValidator],
      nguoiDangKyID: ['', Validators.nullValidator],
      trangThai: ['', Validators.nullValidator]
    });

    this.thietBiService.getAll().subscribe(data => this.dataThietBi = data);
    this.staffsService.findAllByStaffId('-1').subscribe(result => {
      for(let i=0; i< result.length; i++)
      {
        this.staffSelectList= [...this.staffSelectList, {id: result[i].id, fullName: result[i].fullName}];
      }
    });


  }
  public loadStaffs(sid: string)
  {

    this.staffsService.findAllByStaffId('-1').subscribe(result => {
      for(let i=0; i< result.length; i++)
      {
        this.staffSelectList= [...this.staffSelectList, {id: result[i].id, fullName: result[i].fullName}];
      }
      this.staffsService.findAllByStaffId(sid).subscribe(
        x => {
          for(let i=0; i< x.length; i++)
          {

            this.selectedList= [...this.selectedList, x[i].id];
          }

        });
    });


  }
  public showReceive()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-lg'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSelectReadList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      for(let i=0; i< result.length;i++)
      {
        if(this.staffSelectReadList.some(e => e["id"] === result[i].id)==false) {
          this.staffSelectReadList= [...this.staffSelectReadList, {id: result[i].id, fullName: result[i].fullName}];
          this.selectedList= [...this.selectedList, result[i].id];
        }
      }
    });
  }
  get f() { return this.frmGroup.controls; }
  public edit(id: number) {
    this.id=id;
    this.isEdit = true;
    this.dangKyService.getById(id).pipe(first())
      .subscribe(x => {
        this.frmGroup.patchValue(x);
        this.dateCurrent= this.commandUitls.getDate(this.frmGroup.value.ngay);
        this.dangKyNguoiDuyetService.findAllByDangKyId(x.dangKyId, 1).subscribe(
          dk => {
            if(dk.length>0)
              this.loadStaffs(dk.filter(t => t.staffId).join());
          }
        );
      });
  }
  public createItem ()
  {
    this.frmGroup.value.ngay = this.datepipe.transform(this.dateCurrent, 'dd/MM/yyyy');
    this.frmGroup.value.nguoiDangKyID= Sessioncommand.staffId;
    this.frmGroup.value.trangThai =1;
    this.dangKyService.add(this.frmGroup.value).subscribe(
      {
        next: (data) => {
          this.dangKyNguoiDuyetService.addMulti(data.dangKyId,this.uiSelectStaff.selected.join(), 1 ).subscribe(
            {
                  next: (dtnd ) => {
                    },
                      error: error => {
                      }
            }
          );
          this.toastr.success(language.add_success_record, language.message);
          this.onConfirm();
        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }
  public updateItem()
  {
    this.frmGroup.value.ngay = this.datepipe.transform(this.dateCurrent, 'dd/MM/yyyy');
    this.frmGroup.value.nguoiDangKyID= Sessioncommand.staffId;
    this.dangKyService.update(this.frmGroup.value).subscribe({
      next: (data) => {
        this.dangKyNguoiDuyetService.addMulti(data.dangKyId,this.uiSelectStaff.selected.join(), 1 ).subscribe(
          {
            next: (dtnd ) => {
            },
            error: error => {
            }
          }
        );
        this.toastr.success(language.update_success_record, language.message);
        this.onConfirm();
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    if (this.id != 0)
      this.updateItem();
    else
      this.createItem();
  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

